
import Payment from "./Payment";

export const paymentRoutes = () => [
  {
    path: "/admin/payments",
    title: "payments",
    layout: "admin",
    routeType: "admin",
    component: Payment,
  },
];
